'use client';

import React, { useRef } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@ui/components/ui/select';
import { useInputOptions } from '@/hooks/useInputOptions';
import { Length } from '@/lib/db/schema';

interface LengthSelectorProps {
  value: Length | null;
  onChange: (value?: Length) => void;
  className?: string;
}

export default function LengthSelector({ value, onChange, className = '' }: LengthSelectorProps) {
  const { options: lengths } = useInputOptions('length');
  const isUserInteraction = useRef(false);

  const handleChange = (v: string) => {
    if (isUserInteraction.current) {
      onChange((v as Length) || undefined);
    }
  };

  const handleOpenChange = () => {
    isUserInteraction.current = true;
  };

  return (
    <div className={className}>
      <Select value={value || ''} onValueChange={handleChange} onOpenChange={handleOpenChange}>
        <SelectTrigger className="w-full min-w-32 sm:max-w-48">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {lengths.map((length) => (
            <SelectItem key={length.value} value={length.value}>
              {length.display}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
